.documentButtons {
  vertical-align: middle;
  display: flex;
  align-items: baseline;
  gap: var(--spacingMd);
}
